import React, { ReactNode } from 'react';

import { RadioGroup } from '@mui/material';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './SelectSubscriptionCard.module.scss';
import { InfoBox, LbAlert } from '../../../../shared/components/ui-components';
import { CustomerSubscription } from '../../../interfaces/customerSubscription';
import { SubscriptionCard } from '../../../components/SubscriptionRow/SubscriptionCard';
import { isPromoPriceLimited } from '../../../utils/isPromoPriceLimited/isPromoPriceLimited';

type SelectSubscriptionCardProps = {
  subscriptions: CustomerSubscription[];
  discountPercent: number;
  selectedSubscriptionId: number | null;
  setSelectedSubscriptionId: (subscriptionId: number) => void;
  title?: string;
  titleDescription?: ReactNode;
  extraInfo?: ReactNode;
};

const SelectSubscriptionCard = ({
  subscriptions,
  discountPercent,
  selectedSubscriptionId,
  setSelectedSubscriptionId,
  title = 'Subscriptions',
  titleDescription,
  extraInfo,
}: SelectSubscriptionCardProps) => {
  return (
    <InfoBox
      title={
        <TitleWithDescription
          title={title}
          description={titleDescription}
          titleFont="title-16-bold"
        />
      }
    >
      {extraInfo && <div className={classes.extraInfo}>{extraInfo}</div>}
      <RadioGroup value={selectedSubscriptionId}>
        <div className={classes.rows}>
          {subscriptions.map((subscription) => {
            const isSelected = subscription.id === selectedSubscriptionId;

            const isReachMinimalPriceLimit = isPromoPriceLimited(
              subscription.monthlyRenewalPricePromo,
              subscription.monthlyRenewalPriceFinal,
            );

            return (
              <div key={subscription.id} className={classes.item}>
                <SubscriptionCard
                  subscription={subscription}
                  discountPercent={discountPercent}
                  onClick={setSelectedSubscriptionId}
                />
                {isSelected && isReachMinimalPriceLimit && (
                  <LbAlert severity="info" size="small">
                    The minimum charge is $0.50 due to Stripe processing fees.
                    <br />
                    We cannot process payments below this amount because of payment system
                    policies
                  </LbAlert>
                )}
              </div>
            );
          })}
        </div>
      </RadioGroup>
    </InfoBox>
  );
};

export { SelectSubscriptionCard, type SelectSubscriptionCardProps };
